export default {
    RutaApi: "https://api.morro.mx/api",
    //RutaApi: "https://localhost:44362/api",
    RutaFacturas: "/Facturas/",
    RutaFacturasCompleta: "https://facturacion.morro.mx/facturas/"
    //RutaFacturasCompleta: "http://192.168.0.39:8080/facturas/"
  };
  